import Vue from 'vue'
import moment from "moment";

Vue.filter('date', (date) => {
    if (date) {
        return moment(date).format('DD.MM.YYYY');
    } else {
        return '';
    }
});
